module.exports = __webpack_public_path__ + "static/media/cage1.da3fa2c9.png";